import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import axios, { post } from "axios";
import MultiSelect from "react-multi-select-component";
import TextEditor from '../text_editor/TextEditor';
import ErrorBoundary from '../common/ErrorBoundary';
import { log } from 'logrocket';
import './_parentNotification.scss';

const ADD_PARENT_CUSTOM_NOTIFICATION = gql`
  mutation($params:SendParentCustomNotification){
        sendParentCustomNotification(
        params: $params
    )}`;

// ── Expense-style filter services (branches with sections + class list) ───────
const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_EXAM_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};
class ParentNotificationModal extends Component {
    constructor(props) {
        super();
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

        this.state = {
            branches: [],        // raw getBranches result (with sections)
            allClasses: [],      // raw getExamClasses result
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],
            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],
            studentsOptions: [],
            selectedStudents: [],
            students_error: "",
            branchWiseData: [],
            classWiseStudentData: [],
            sectionWiseStudentData: [],
            title: "",
            title_error: "",
            subTitle: "",
            subTitle_error: "",
            schedule_time: currentDateTime,
            ldescription: "",
            ldescription_error: "",
            loader: 0,
            submitError: "",
            submitted: false
        }
    }

    async componentDidMount() {
        try {
            const [branches, allClasses] = await Promise.all([this.fetchBranches(), this.fetchClasses()]);
            this.setState({ branches, allClasses }, () => {
                if (branches.length > 0) this.applyBranch(branches[0].id);
            });
        } catch (e) {
            console.error("Parent notification filter load failed", e);
        }
    }

    // Branches (with sections) — same service the Expense module uses.
    fetchBranches = async () => {
        const institution_id = parseInt(Cookies.get("institutionid"));
        const res = await this.props.client.query({
            query: GET_BRANCHES,
            variables: { institution_id },
            fetchPolicy: "network-only",
        });
        let branches = res.data.getBranches || [];
        if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
            branches = branches.filter((b) => String(b.id) === String(Cookies.get("branch_id")));
        }
        return branches;
    };

    // Institution class list — same service the Expense / Document modules use.
    fetchClasses = async () => {
        const res = await this.props.client.query({
            query: GET_EXAM_CLASSES,
            variables: { id: 1 },
            fetchPolicy: "network-only",
        });
        return res.data.getExamClasses || [];
    };

    // Populate class / section / student options for a branch (everything pre-selected).
    applyBranch = (branchId) => {
        const branch = this.state.branches.find((b) => String(b.id) === String(branchId));
        const sections = branch ? (branch.sections || []) : [];

        // Classes from getExamClasses, scoped to the branch's sections.
        const classIds = [...new Set(sections.map((s) => Number(s.class_id)))];
        const getClassArr = this.state.allClasses
            .filter((c) => classIds.includes(Number(c.id)))
            .map((c) => ({ value: c.id, label: c.class }));

        // Sections from the branch (deduped).
        const seen = new Set();
        const getSectionArr = [];
        sections.forEach((s) => {
            if (!seen.has(s.id)) { seen.add(s.id); getSectionArr.push({ value: s.id, label: s.section_name }); }
        });

        // Students for the branch.
        const StudentsData = this.props.getNewEducationalStudents || [];
        const branchWiseData = StudentsData.filter((a) => a.branch_id == branchId).map((item) => ({ ...item }));
        const studentsArray = branchWiseData.map((item) => ({
            value: item.student_id,
            label: `${item.roll_no} => ${item.student_name}`,
            parent_mobile: item.parent_mobile,
        }));

        this.setState({
            branchSearchval: branch ? { value: branch.id, label: branch.branch_name } : "",
            branch: branch ? branch.branch_name : "",
            branchSearch: branchId,
            branchError: "",
            getClassArr,
            classSelectedvalue: getClassArr,
            getSectionArr,
            sectionSelectedvalue: getSectionArr,
            studentsOptions: studentsArray,
            selectedStudents: studentsArray,
            branchWiseData,
            classWiseStudentData: branchWiseData,
            sectionWiseStudentData: branchWiseData,
        });
    };

    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {
            let classSelectedvalue = e ? e.map((c) => ({ label: c.label, value: c.value })) : [];

            if (classSelectedvalue.length > 0) {
                // Sections from the branch's getBranches sections, filtered by selected classes.
                const branch = this.state.branches.find((b) => String(b.id) === String(this.state.branchSearch));
                const sections = branch ? (branch.sections || []) : [];
                const selectedClassIds = classSelectedvalue.map((c) => Number(c.value));
                const seen = new Set();
                const getSectionArr = [];
                sections
                    .filter((s) => selectedClassIds.includes(Number(s.class_id)))
                    .forEach((s) => {
                        if (!seen.has(s.id)) { seen.add(s.id); getSectionArr.push({ value: s.id, label: s.section_name }); }
                    });

                // Students for the branch filtered by the selected classes.
                const branchWiseData = this.state.branchWiseData || [];
                let classWiseData = [];
                classSelectedvalue.forEach((c) => {
                    classWiseData.push(...branchWiseData.filter((student) => student.class_id == c.value));
                });
                const studentsArray = classWiseData.map((item) => ({
                    value: item.student_id,
                    label: `${item.roll_no} => ${item.student_name}`,
                    parent_mobile: item.parent_mobile,
                }));

                this.setState({
                    classSelectedvalue,
                    classError: "",
                    getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    classWiseStudentData: classWiseData,
                    sectionWiseStudentData: classWiseData,
                });
            } else {
                this.setState({
                    classSelectedvalue: [],
                    classError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }


                let classWiseStudentData = this.state.classWiseStudentData;

                console.log("examWiseData", classWiseStudentData);

                let studentsArray = [];
                let sectionWiseStudentData = [];


                if (classWiseStudentData.length > 0) {
                    console.log("eeeeee", e);
                    e.map((section) => {
                        let data = classWiseStudentData.filter((student) => student.section_id == section.value);
                        sectionWiseStudentData.push(...data)
                    });

                    sectionWiseStudentData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`,
                            parent_mobile: item.parent_mobile
                        }
                        studentsArray.push(newObj);
                    });
                }



                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    sectionError: "",
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    sectionWiseStudentData: sectionWiseStudentData,
                });
            } else {
                this.setState({
                    sectionSelectedvalue: [],
                    sectionError: "",
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "student") {
            // let studenttopic = Array();
            let studenttopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const stuval = e[i];
                    const newObj = {
                        label: stuval.label,
                        value: stuval.value,
                        parent_mobile:stuval.parent_mobile
                    }
                    studenttopicvalue.push(newObj);
                    // studenttopic.push(stuval.value);
                }
                this.setState({
                    selectedStudents: studenttopicvalue,
                    students_error: ""
                });
            }
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            this.state.branches.map((b) => {
                getArray.push({ value: b.id, label: b.branch_name });
            });
        }
        return getArray;
    }

    selecthandleBranch = (name, value) => {
        if (name == "branchSearch" && value != "0") {
            this.applyBranch(value);
        }
        this.setState({ [name]: value });
    }

    handleFormChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "title") {
            this.setState({ title: value, title_error: "" })
        }
        if (name == "subTitle") {
            this.setState({ subTitle: value, subTitle_error: "" })
        }
        if (name == "schedule_time") {
            this.setState({ schedule_time: value })
        }
        //    if (name == "image") {
        //         var file = e.target.files[0];
        //         let fileread = new FileReader();
        //         this.setState({
        //             image_filename: "Uploading...",
        //         });

        //         fileread.readAsDataURL(file);
        //         fileread.onload = async (e) => {
        //             console.log("Target", e.target);

        //             let fobj = {
        //                 stream: e.target.result,
        //                 filename: file.name,
        //                 mimetype: file.type,
        //             };

        //             const upload = await this.fileUpload(file, fobj.stream);
        //             console.log("file uploaded", upload);

        //             if (upload.data.result == "success") {
        //                 this.setState({ image: upload.data.filename, image_error:"" });

        //                 this.setState({
        //                     image_filename: file.name,
        //                 });
        //             }
        //         };

        //     }
    }

    handleEditorChange = (content) => {
        this.setState({
            ldescription: content,
            ldescription_error: ""
        })
        // , () => {
        //     this.validateField("ldescription", "1");
        // });

    }

    handleFormSubmit = e => {
         e.preventDefault();
        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Please select class" });
            return ""
        }

        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Please select section" });
            return ""
        }
        if (!this.state.selectedStudents.length) {
            this.setState({ students_error: "Please select students" });
            return ""
        }

        if (this.state.title == "") {
            this.setState({ title_error: "Please enter title", })
            return ""
        }
        if (this.state.subTitle == "") {
            this.setState({ subTitle_error: "Please enter message", })
            return ""
        }
        // if (this.state.image == "") {
        //     this.setState({ image_error: "Please choose file", })
        //     return ""
        // }
        if (this.state.ldescription == "") {
            this.setState({ ldescription_error: "Please enter description", })
            return ""
        }

        const params = {
            branch_id: this.state.branchSearch,
            institute_id: parseInt(Cookies.get("institutionid")),
            class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
            section_id: this.state.sectionSelectedvalue.map((sectionid) => sectionid.value).toString(),
            notification_title: this.state.title,
            notification_subtitle: this.state.subTitle,
            long_description: this.state.ldescription,
            schedule_time: moment(this.state.schedule_time).unix().toString(),
            parent_mobile: this.state.selectedStudents.filter((a) => a.parent_mobile != null).map((i) => i.parent_mobile).toString(),
            exam_id: ""
        }

        this.setState({
            loader: 1
        });

        this.addParentCustomNotification(params);

    }

    sendPushToParents = async (parent_mobiles, title, body) => {
        const studentApiUrl = process.env.REACT_APP_STUDENT_API_URL;
        if (!studentApiUrl || !parent_mobiles) return;
        try {
            await fetch(studentApiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    query: `mutation SendPush($mobiles: String!, $title: String!, $body: String!) {
                        sendParentPushNotification(parent_mobiles: $mobiles, title: $title, body: $body)
                    }`,
                    variables: { mobiles: parent_mobiles, title, body },
                }),
            });
        } catch (e) {
            console.error('Push notification failed (non-blocking):', e);
        }
    };

    addParentCustomNotification = async (params) => {
        try {
            await this.props.addParentCustomNotification({
                variables: {
                    params,
                },
                update: (store, { data }) => {
                    if (data && data.sendParentCustomNotification) {
                        if (this.props.refetchNotifications) {
                            this.props.refetchNotifications();
                        }
                        this.props.onHide();
                    } else {
                        console.error("sendParentCustomNotification returned false/null", data);
                        this.setState({ loader: 0, submitError: "Failed to send notification. Please try again." });
                    }
                },
            });
        } catch (err) {
            console.error("addParentCustomNotification error:", err);
            this.setState({ loader: 0, submitError: err.message || "An error occurred. Please try again." });
        }
    };

    SetpageLoad = () => {
        this.setState({ submitted: false, submitError: "", loader: 0 });
    };
    render() {
        console.log("state", this.state);
        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        let studentselectall = true;
        let studentlabelledBy = "Select";
        let studentdisablesearch = false;

        if (this.state.getClassArr.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }

        if (this.state.getSectionArr.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }

        if (this.state.studentsOptions.length > 0) {
            studentselectall = true;
            studentdisablesearch = false;
        }
        else {
            studentdisablesearch = true;
            studentselectall = false;
            studentlabelledBy = "student"
        }
         return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                size="lg"
                dialogClassName="pn-modal"
                aria-labelledby="parent-notification-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title><i className="fas fa-bell" /> Send Parent Notification</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                <SelectDropDown
                                    stateData={this.state.branchSearchval}
                                    handleChange={this.selecthandleBranch}
                                    name="branchSearch"
                                    options={this.dropDownGetValues("branchSearch")}
                                    placeholderName={'Branch'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Classes are selected.",
                                        "selectSomeItems": classlabelledBy
                                    }}
                                    disableSearch={classdisableSearch}
                                    hasSelectAll={classselectall}
                                    options={this.state.getClassArr}
                                    value={this.state.classSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                    labelledBy={"class"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.classError}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectSection">
                                <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Sections are selected.",
                                        "selectSomeItems": sectionlabelledBy
                                    }}
                                    disableSearch={sectiondisableSearch}
                                    hasSelectAll={sectionselectall}
                                    options={this.state.getSectionArr}
                                    value={this.state.sectionSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                    labelledBy={"section"}
                                />
                                <Form.Text className="form-text text-danger"> {this.state.sectionError}</Form.Text>

                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectStudent">
                                <Form.Label className="text-uppercase font-weight-bold">Students</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Students are selected.",
                                        "selectSomeItems": studentlabelledBy
                                    }}
                                    disableSearch={studentdisablesearch}
                                    hasSelectAll={studentselectall}
                                    options={this.state.studentsOptions}
                                    value={this.state.selectedStudents}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "student")}
                                    labelledBy={"student"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.students_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Title</Form.Label>
                                <Form.Control placeholder='Enter Title' name='title' onChange={this.handleFormChange} value={this.state.title}></Form.Control>
                                <Form.Text className="form-text text-danger">{this.state.title_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Subtitle</Form.Label> <br />
                                <Form.Control as="textarea" rows="2" type="text" placeholder="Enter subTitle" name="subTitle" onChange={this.handleFormChange} value={this.state.message} />
                                <Form.Text className="form-text text-danger">{this.state.subTitle_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Schedule Time</Form.Label> <br />
                                <Form.Control type="datetime-local" name="schedule_time" onChange={this.handleFormChange} value={this.state.schedule_time} />
                            </Form.Group>
 
                            <Form.Group as={Col} lg={12} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Long Description</Form.Label>
                                <ErrorBoundary fallback={<div className="alert alert-warning">Editor could not be loaded. Please refresh.</div>}>
                                    <TextEditor handleEditorChange={this.handleEditorChange} value={this.state.ldescription} />
                                </ErrorBoundary>
                                <Form.Text className="form-text text-danger"> {this.state.ldescription_error} </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 d-flex flex-column align-items-end">
                        <button className="pn-modal-submit" onClick={this.handleFormSubmit} disabled={this.state.loader == 1}>
                            {
                                this.state.loader == 1 ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (<i className="fas fa-paper-plane" />)
                            }
                            Send Notification
                        </button>
                        {this.state.submitted == true && (
                            <p className="text-success mt-2 mb-0">Notification sent successfully</p>
                        )}
                        {this.state.submitError && this.state.submitError != "" && (
                            <span className="text-danger mt-2">{this.state.submitError}</span>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default compose(
    withApollo,
    graphql(ADD_PARENT_CUSTOM_NOTIFICATION, {
        name: "addParentCustomNotification"
    })
)(ParentNotificationModal);
// NARESH